'use client'

import React, { useState } from "react"
// import { BlogSwitcher as TerraBlogSwitcher } from "trimble-terra/BlogSwitcher"
import { BlogSwitcher as TerraBlogSwitcher } from "trimble-terra"
import { useRouter } from "next/navigation"
import { normalToMachineTheme } from "@/lib/utils"

const FormatBlogSwitcher = (data: any, draftEnabled: boolean) => {
  const [selection, setSelection] = useState("")
  const router = useRouter()

  const blogSwitcherData = data?.data || null
  const dropdownItems = blogSwitcherData.dropdownOptionsCollection?.items.map((item: any) => {
    return { label: item?.textLabel, url: item?.url }
  })

  const handleSelectionChange = (value: string) => {
    setSelection(value)
  }

  const handleNavigate = (url: string) => {
    if (url.startsWith("/")) {
      // Internal route
      router.push(url)
    } else {
      // External route - open in new tab
      window.open(url, "_blank")
    }
  }
  

  return (
    <div className="blog-switcher-section">
      <TerraBlogSwitcher
        header={blogSwitcherData.header}
        dropdownTitle={blogSwitcherData.dropdownLabel}
        dropdownOptions={dropdownItems}
        selection={selection}
        setSelection={handleSelectionChange}
        presetTheme={normalToMachineTheme(blogSwitcherData.theme)}
        onNavigate={handleNavigate} // <-- This triggers your Next router or new tab
        isWrapped={true}
      />
    </div>
  )
}

export default FormatBlogSwitcher
